import { render, staticRenderFns } from "./letter-avatar.vue?vue&type=template&id=7c1c99f0&scoped=true"
import script from "./letter-avatar.vue?vue&type=script&lang=js"
export * from "./letter-avatar.vue?vue&type=script&lang=js"
import style0 from "./letter-avatar.vue?vue&type=style&index=0&id=7c1c99f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c99f0",
  null
  
)

export default component.exports